import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Reveal from "../animations/Reveal";
import { replaceStringWithShandeChildAmount } from "../../helpers/dataHelper";

function CtaSection() {
    const { t } = useTranslation();
    const description = replaceStringWithShandeChildAmount(t("ctaDescription"));
    return (
        <section className="landing-cta">
            <Reveal className="container" stagger={0.1}>
                <div className="landing-cta-eyebrow" data-reveal>{t("ctaEyebrow")}</div>
                <h2 className="landing-cta-title" data-reveal>{t("ctaTitle")}</h2>
                <p className="landing-cta-desc" data-reveal>{description}</p>
                <div className="landing-cta-actions" data-reveal>
                    <Link className="landing-btn landing-btn-dark" to="/donate">{t("ctaDonate")}</Link>
                    <Link className="landing-btn landing-btn-ghost" to="/career">{t("ctaVolunteer")}</Link>
                </div>
                <div className="landing-cta-meta" data-reveal>{t("ctaMeta")}</div>
            </Reveal>
        </section>
    );
}
export default CtaSection;